import {
  Autocomplete,
  Checkbox,
  FormHelperText,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
// eslint-disable-next-line no-unused-vars
import { CheckBoxOutlineBlank, CheckBox } from "@mui/icons-material";

const icon = <CheckBoxOutlineBlank />;
const checkedIcon = <CheckBox />;

const MultipleTreeSelect = (props) => {
  const {
    label,
    name,
    formik,
    options,
    required,
    propertyDescription1,
    propertyDescription2,
    ...rest
  } = props;

  const handleChange = (value) => {
    const _values = [];
    value.map((value) => {
      _values.push(value.id);
    });
    formik.setFieldValue(name, _values);
  };
  return (
    <>
      <Grid>
        <Box
          sx={{
            borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
            paddingLeft: formik.errors[name] ? "16px" : "",
          }}
        >
          <InputLabel
            htmlFor={label}
            sx={{
              textAlign: "left",
              textStyle: "none",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                marginBottom: "15px",
                fontWeight: required ? "bold" : "500",
              }}
            >
              {label}
            </Typography>
            {propertyDescription1 ||
              (propertyDescription2 && (
                <Typography variant="subtitle1" color="light.main">
                  {propertyDescription1} <br></br>
                  {propertyDescription2}
                </Typography>
              ))}
          </InputLabel>
          <Autocomplete
            sx={{ minWidth: 200 }}
            fullWidth
            multiple
            id="checkboxes-tags"
            options={options}
            disableCloseOnSelect
            onChange={(_, value) => handleChange(value)}
            getOptionLabel={(option) => option.description}
            getOptionDisabled={(option) => option.hasChildren}
            {...rest}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.id}>
                <Box
                  sx={{
                    display: "flex",
                    ml: option.level === 1 ? 0 : 3 * (option.level - 1),
                  }}
                >
                  {!option.hasChildren && (
                    <Checkbox
                      sx={{ ml: -1 }}
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={selected}
                    />
                  )}
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    {option.description}
                  </Box>
                </Box>
              </li>
            )}
            renderInput={(params) => <TextField {...params} />}
          />
          {!!formik.errors[name] && (
            <FormHelperText error>
              <Typography
                variant="body1"
                sx={{
                  marginTop: "16px",
                  fontWeight: "bolder",
                }}
              >
                {formik.errors[name]}
              </Typography>
            </FormHelperText>
          )}
        </Box>
      </Grid>
    </>
  );
};

export default MultipleTreeSelect;
